/**
 * 金额过滤器
 * null, undefined, '', 返回'--', 其他返回金额保留两位
 */
export default function amountFormat(val) {
    const invalidMap = [
        null,
        undefined,
        '',
    ];

    return invalidMap.some(v => v === val) ? '--' : Number(val).toFixed(2);
}
